import { toDisplayKmh } from './constants.ts';

/** Sharpest heading change in degrees, or `0` when every move was straight / unknown. */
export function tightestTurnDeg(angles: readonly (number | null)[]): number {
  let tightest = 0;

  for (const angle of angles) {
    if (angle !== null && Number.isFinite(angle) && angle > tightest) {
      tightest = angle;
    }
  }

  return tightest;
}

export function averageSpeedKmh(moveSpeeds: readonly number[]): number {
  if (moveSpeeds.length === 0) {
    return 0;
  }

  return (
    moveSpeeds.reduce((sum, speed) => sum + toDisplayKmh(speed), 0) / moveSpeeds.length
  );
}

export function maxSpeedKmh(moveSpeeds: readonly number[]): number {
  return moveSpeeds.reduce((top, speed) => Math.max(top, toDisplayKmh(speed)), 0);
}

export function formatTurnDeg(degrees: number): string {
  if (!Number.isFinite(degrees) || degrees <= 0) {
    return '—';
  }

  return `${Math.round(degrees)}°`;
}
